import { ROUTE_PATH_PRIVACY_POLICY, ROUTE_PATH_TERMS_CONDITIONS } from '../../constants';
import { ActivatePageTranslations } from '../types';

export const translations: ActivatePageTranslations = {
  docTitle: 'Activate',
  beforeUnloadPrompt: 'Do you want to leave this page? Changes you made may not be saved.',
  howWeSecureInfoLink: {
    href: '#',
    children: 'How do we secure your information?'
  },
  ineligibleModalTitle: 'You are not eligible to register for OnGuard',
  steps: {
    personalInfo: {
      title: 'Personal Information',
      leadText: [
        '<p>Congratulations! You are eligible to receive OnGuard powered by ID Assist  as a feature of your BMO Bank Plan.</p>',
        '<p>OnGuard collects this information to create your subscription and',
        'to provide service to you.</p>'
      ].join('\n'),
      footnote: [
      ].join('\n'),
      form: {
        field: {
          firstName: {
            label: 'Name',
            'aria-label': 'First Name',
            placeHolder: 'First Name',
            error: {
              required: 'Please enter your First Name.',
              tooShort: [
                'First Name must be 2 – 30 characters long and may contain the following',
                'characters: letters, single hyphen at a time (-), single space at a time.'
              ].join('\n'),
              tooLong: [
                'First Name must be 2 – 30 characters long and may contain the following',
                'characters: letters, single hyphen at a time (-), single space at a time.'
              ].join('\n'),
              patternMismatch: [
                'First Name must be 2 – 30 characters long and may contain the following',
                'characters: letters, single hyphen at a time (-), single space at a time.'
              ].join('\n')
            }
          },
          lastName: {
            label: 'Last Name',
            placeHolder: 'Last Name',
            error: {
              required: 'Please enter your Last Name.',
              tooShort: [
                'Last Name must be 2 – 30 characters long and may contain the following characters: letters,',
                'single hyphen at time (-), single space at a time.'
              ].join('\n'),
              tooLong: [
                'Last Name must be 2 – 30 characters long and may contain the following characters: letters,',
                'single hyphen at time (-), single space at a time.'
              ].join('\n'),
              patternMismatch: [
                'Last Name must be 2 – 30 characters long and may contain the following characters: letters,',
                'single hyphen at time (-), single space at a time.'
              ].join('\n')
            }
          },
          birthDate: {
            label: 'Date of Birth',
            'aria-label': 'Why do I need to provide my date of birth?',
            helpText: 'Your Date of Birth is required to set up your credit monitoring service and confirm you are at least 18 years of age.',
            error: {
              required: 'Please enter your Date of Birth.',
              badInput: 'Please enter a valid Date of Birth (ex. YYYY/MM/DD).',
              ineligible: [
                'You are not eligible to register for OnGuard because you are below the age of majority for your province.',
                'Please contact us at 1-866-327-3078 if you need further assistance.'
              ].join('\n'),
              apiError: [
                'You must be at least 18 years old to register.'
              ].join(' ')
            }
          },
          dobMonth: {
            label: '',
            'aria-label': 'Month',
            placeHolder: 'Month'
          },
          dobDay: {
            label: 'Day',
            placeHolder: 'Day'
          },
          dobYear: {
            label: 'Year',
            placeHolder: 'Year'
          },
          phoneNumber: {
            label: 'Phone Number',
            // placeHolder: 'Home, office, mobile, etc.',
            placeHolder: 'ex. 416-555-1234',
            error: {
              required: 'Please enter your Phone Number.',
              tooShort: 'Please enter a valid Phone Number (ex. 416-555-1234).',
              tooLong: 'Please enter a valid Phone Number (ex. 416-555-1234).',
              patternMismatch: 'Please enter a valid Phone Number (ex. 416-555-1234).',
              apiError: [
                'Looks like you have already registered an account with us using this name and',
                'phone number. Please use a different name and phone number to register.'
              ].join(' ')
            }
          },
          emailAddress: {
            label: 'Email Address',
            'aria-label': 'Email address',
            placeHolder: 'john@sample.com',
            helpText: [
              'Your email address will be your User ID. Please use a unique personal',
              'email address that belongs to you and will be easily remembered.'
            ].join('\n'),
            error: {
              required: 'Please enter your Email Address.',
              tooShort: 'Please enter a valid Email Address (ex. bobsmith@example.com).',
              tooLong: 'Please enter a valid Email Address (ex. bobsmith@example.com).',
              patternMismatch: 'Please enter a valid Email Address (ex. bobsmith@example.com).',
              activated: [
                'Sorry, based on the information provided, your OnGuard subscription has already',
                'been activated or this email address is associated with another OnGuard subscription.'
              ].join('\n'),
              ineligible: [
                'Sorry, based on the information provided, you are not eligible to receive OnGuard as part of your BMO Bank Plan.',
                'Please contact us at 1-866-327-3078 if you need further assistance. '
              ].join('\n'),
              apiError: [
                'Looks like you have already registered an account with us using this email address.',
                'Please use a different email address to register.'
              ].join(' ')
            }
          },
          marketingOptIn: {
            label: ''
          }
        },
        action: {
          cancel: {
            label: 'Cancel'
          },
          submit: {
            label: 'Next'
          }
        }
      }
    },
    contactInfo: {
      title: 'Address',
      leadText: [
        '<p>Congratulations! You are eligible to receive OnGuard powered by ID Assist as a feature of your BMO Bank Plan.</p>',
        '<p>OnGuard collects this information to create your subscription and to provide service to you.</p>'
      ].join('\n'),
      form: {
        field: {
          addressLine1: {
            label: 'Address',
            'aria-label': 'Street Address',
            placeHolder: 'Street Address',
            error: {
              required: 'Please enter your Address.',
              tooShort: [
                'Address must be 3 – 50 characters long and may contain the following characters:',
                `letters, numbers, single hyphen at a time (-), single space at a time, period (.), apostrophe ('), comma (,).`
              ].join('\n'),
              tooLong: [
                'Address must be 3 – 50 characters long and may contain the following characters:',
                `letters, numbers, single hyphen at a time (-), single space at a time, period (.), apostrophe ('), comma (,).`
              ].join('\n'),
              patternMismatch: [
                'Address must be 3 – 50 characters long and may contain the following characters:',
                `letters, numbers, single hyphen at a time (-), single space at a time, period (.), apostrophe ('), comma (,).`
              ].join('\n')
            }
          },
          addressLine2: {
            label: 'Apartment, Suite, etc.',
            placeHolder: 'Apt, Suite, etc.',
            error: {
              tooLong: 'Address may not be more than 40 characters in length.',
              patternMismatch: [
                'Address may contain the following characters:',
                'letters, numbers, single hyphen at a time (-),',
                `single space at a time, period (.), apostrophe ('), comma (,).`
              ].join('\n')
            }
          },
          cityName: {
            label: 'City',
            placeHolder: 'City',
            error: {
              required: 'Please enter your City.',
              tooShort:  [
                'City must be 2 – 50 characters long and may contain the following characters:',
                'letters, numbers, single hyphen at a time (-), single space at a time, period (.), apostrophe (\').'
              ].join('\n'),
              tooLong:  [
                'City must be 2 – 50 characters long and may contain the following characters:',
                'letters, numbers, single hyphen at a time (-), single space at a time, period (.), apostrophe (\').'
              ].join('\n'),
              patternMismatch: [
                'City must be 2 – 50 characters long and may contain the following characters:',
                'letters, numbers, single hyphen at a time (-), single space at a time, period (.), apostrophe (\').'
              ].join('\n')
            }
          },
          provinceCode: {
            label: 'Province',
            placeHolder: 'Province',
            error: {
              required: 'Please select your Province.'
            }
          },
          postalCode: {
            label: 'Postal Code',
            placeHolder: 'XNXNXN',
            error: {
              required: 'Please enter your Postal Code.',
              tooShort: 'Please enter a valid Postal Code (i.e. M1M 1M1).',
              tooLong: 'Please enter a valid Postal Code (i.e. M1M 1M1).',
              patternMismatch: 'Please enter a valid Postal Code (i.e. M1M 1M1).'
            }
          },
          acceptTermsConditions: {
            label: [
              'By clicking Submit,',
              `I agree that I have read and accepted the <a tabindex="0" data-router-link target="_blank" href=${ROUTE_PATH_TERMS_CONDITIONS}>`,
              `Terms and Conditions</a> and <a tabindex="0" data-router-link target="_blank" href=${ROUTE_PATH_PRIVACY_POLICY}>Privacy Policy</a>`,
              'that apply to the services provided by OnGuard powered by ID Assist, and provide authorization for Sigma Loyalty Group Inc.,',
              'the provider of OnGuard, to obtain my credit information to confirm my identity and begin monitoring my credit',
              'bureau file.'
            ].join(' '),
            error: {
              required: 'Please tick mark this checkbox to accept Terms and Conditions.'
            }
          },
          recaptcha: {
            label: '',
            error: {
              required: 'Please resolve the CAPTCHA challenge.'
            }
          }
        },
        action: {
          previous: {
            label: 'Previous'
          },
          submit: {
            label: 'Submit'
          }
        }
      }
    },
    confirmation: {
      progressBadgeTitle: 'Confirmation',
      title: 'Your identity protection services have begun!',
      leadText: [
        '<p>Thank you for registering for your complimentary OnGuard subscription!</p>',
        '<p>The information you provided during enrollment will be automatically monitored',
        'online and at the credit bureau. Maximize your identity protection by setting up your',
        'online account today, where you can register even more information for online identity monitoring',
        'and access your alerts.</p><p>Please check your email for a link from OnGuard to set up your online account',
        'and  access your identity protection services.</p>'
      ].join('\n'),
      footnote: '',
      form: {
        field: {
          eToken: {
            label: ''
          }
        },
        action: {
          setupAccount: {
            label: 'Set-up Identity Guard Account'
          }
        }
      }
    },
    partialConfirmation: {
      title: 'There was a problem setting up your account...',
      leadText: [
        '<p>Thank you for registering for your complimentary OnGuard subscription!</p>',
        '<p>We have received your enrollment details, but experienced a problem processing your request.',
        'You will receive an email containing the next steps you need to take to set up your',
        'identity protection services within 24 hours.</p>'
      ].join('\n')
    }
  }
};
